export default __webpack_public_path__ + "static/automobile-3d-video-cube-6d856ec5c935a490e55fd733f4b8e9cd.gif";